;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.business')
    .service('ReferersService', ReferersService)

  ReferersService.$inject = ['$uibModal']
  function ReferersService ($uibModal) {
    var self = this

    _.extend(self, {
      // Public Attributes
      // Public Methods
      promptSelection: promptSelection
    })

    /**
     * Prompt a modal, return an Array of referer as a promise
     * @returns {Promise<Referer[]>}
     */
    function promptSelection (selectedUsers) {
      return $uibModal.open({
        templateUrl: '/app/common/business/referers/referers.html',
        resolve: {
          selectedUsers: function () {
            return selectedUsers
          }
        },
        size: 'lg',
        controller: ['UserManager', '$uibModalInstance', 'selectedUsers', function (UserManager, $uibModalInstance, selectedUsers) {
          var self = this

          _.extend(self, {
            // Public Attributes
            isValid: false,
            selection: [],
            // Public Methods
            cancel: cancel,
            close: close,
            clickReferer: clickReferer,
            selectAll: selectAll,
            unselectAll: unselectAll
          })

          init()

          function init () {
            self.loadingTeams = true
            self.loadingReferers = true
            // TODO Switch from Technician to User when route is ready
            UserManager.getReferers().then(function (data) {
              self.referers = data.data
              self.loadingReferers = false
              if (selectedUsers !== undefined && selectedUsers.length > 0) {
                self.selection = selectedUsers
                var index
                for (var i = 0; i < self.selection.length; i++) {
                  index = _.findIndex(self.referers, function (r) {
                    return r._id === self.selection[i]._id
                  })
                  self.selection[i].selected = true
                  self.referers[index].selected = true
                }
              }
            })
          }

          function selectAll () {
            self.selection = self.referers
            for (var i = 0; i < self.referers.length; i++) {
              self.referers[i].selected = true
            }
          }

          function unselectAll () {
            self.selection = []
            for (var i = 0; i < self.referers.length; i++) {
              self.referers[i].selected = false
            }
          }

          function clickReferer (referer) {
            if (referer.selected === true) {
              _.remove(self.selection, function (s) {
                return s._id === referer._id
              })
              referer.selected = false
            } else {
              self.selection.push(referer)
              referer.selected = true
            }
          }

          function close () {
            for (var i = 0; i < self.selection.length; i++) {
              delete self.selection[i].selected
            }
            $uibModalInstance.close(self.selection)
          }

          function cancel () {
            $uibModalInstance.dismiss()
          }
        }],
        controllerAs: 'select'
      }).result
    }
  }
})(window.angular, window._)
